if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

    
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault(); 
    (async () => {

      var submitBtnId='';
   if (evt.target.dataset.type !== null) {
    //submitBtnId = evt.submitter.id;
    submitBtnId = evt.target.dataset.type;
  }
  /* var cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(response => {  return response });

    var allowA2CProduct= true;
    var allowA2CProductForGiftBox= true;
    var GiftBoxExist= true;
    var mixedCart= false
    cartContents.items.forEach(function(item){
    if(item.product_type == "Gift Card"){allowA2CProduct= false;}
    if (item.properties && item.properties._giftBox) { GiftBoxExist = false; }
    else { mixedCart = true; }
    })
      var formDataValue = new FormData(this.form);
      var productType =formDataValue.get('product_type');
      if(formDataValue.get('gift_box')){var giftBox =formDataValue.get('gift_box'); }
      console.log("mixedCart=>",mixedCart)
      if(cartContents.item_count > 0 && productType =='Gift Card') {allowA2CProduct= false; }
       if(cartContents.item_count > 0 && giftBox && GiftBoxExist && mixedCart) {allowA2CProductForGiftBox= false; }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (!allowA2CProduct) {  document.querySelector('#clearCartMessage').classList.add('Toastify_popup_open'); return false;}
      if (!allowA2CProductForGiftBox) {  document.querySelector('#clearCartMessageForGiftBox').classList.add('Toastify_popup_open'); return false;}
 */     
      this.handleErrorMessage();


      
     var bundleSet= document.querySelector('#bundleSet');
     var bundleData='';
      if(submitBtnId == 'add-to-cart-form-bundle') {  
       var itemLength = parseInt(document.querySelector('#bundleSetItemsCount').value);
       var productUrl = document.querySelector('#productUrl').value;
       let items = [];
       for(var i=1;i<=itemLength; i++){
      let maskId = document.querySelector('#bundleItemID_'+i+'').value;
       items.push(
            {
              'quantity': 1,
              'id': maskId,
              'properties': {
                '_combo': productUrl
              }
            }
         );
     } 

   bundleData={ "items": items ,"sections":["cart-drawer","cart-icon-bubble"],"sections_url":window.location.pathname}; 
    }

      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.add_to_cart').classList.add('hidden');
      this.querySelector('.updateBtnText').classList.add('hidden');
      
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      //return false;

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      console.log("jjjj",formData.get('product_type'));
     var formId= this.form.getAttribute('id');
      var formIdSplit = formId.split('--');
      if(formIdSplit == 'product-form-template')
      {
      
    // Custom code to block the maximum qty
      
      var productHandle= document.querySelector('.productFormQty').dataset.itemHandle;
        console.log(productHandle)
       var cartSettingsInput= parseInt(cartSettings.cart_max_input);
       if(document.querySelector('[data-item-'+productHandle+']'))
       { 
        var qtyInputFromForm = parseInt(document.querySelector('.productFormQty').value);
        var currentQty= parseInt(document.querySelector('[data-item-'+productHandle+']').dataset.currentquantity);
        var combineQty = (qtyInputFromForm) + (currentQty);
       
      if (combineQty > cartSettingsInput)
      {
       alert(cartSettings.cart_max_input_error_message); 
       this.submitButton.classList.remove('loading');
       this.submitButton.removeAttribute('aria-disabled');
       return false;
      }
       }
      
      if(document.querySelector('[name="quantity"]').value > cartSettingsInput)
       {
        alert(cartSettings.cart_max_input_error_message); 
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        return false;
       }
      } 
      //ends

      var sectionData= this.cart.getSectionsToRender();
    
      if (this.cart) {
        formData.append('sections', sectionData.map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
     config.body = formData;
     const body = JSON.stringify(bundleData);
      //fetch(`${routes.cart_add_url}`, config)
     if(bundleData !='') { var customConfig= {...fetchConfig(), ...{ body }}} else {var customConfig= config}
     // fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})}
      console.log(customConfig)
      fetch(`${routes.cart_add_url}`, customConfig) 
        .then((response) => response.json())
        .then(async(response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
         if(window.location.href.indexOf("cart") > -1) {
             window.location = window.routes.cart_url;
        }
      else {

   var cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(response => {
    const filteredItems = response.items.filter(item => item.product_type !== 'Gift Kits');
    const totalCents = filteredItems.reduce((sum, item) => sum + item.line_price, 0);
    const cartTotal = totalCents / 100; // Convert from cents
      if(document.getElementById('CartAutoMultipleTierNew')){setTimeout(function(){updateProgressBar(cartTotal);},2000);}
       return response 
       });
     //cartAutoMultipleTier(cartContents);
        if(document.getElementById('CartAutoMultipleTierNew')){ cartAutoMultipleTierNew(cartContents); }
        if(document.querySelector(".CartGwpOfferBuyXGetY_sectionFound")) {
         checkCartForQualifyingItems();
          }
          if(document.querySelector(".CartGwpOfferBuyX2GetY_sectionFound")) {
         checkCartForQualifyingItems2();
          }
           if(document.querySelector(".CartTotalOffer_sectionFound")) {
         checkCartForOffer();
          }
          if(document.querySelector(".CartTotalOffer2_sectionFound")) {
         checkCartForOffer2();
          }
          document.querySelector("#cart-icon-bubble").click();
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response, false) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response, false);
          }
        if(document.querySelector('#recommendedProductsScript')) { eval(document.querySelector("#recommendedProductsScript").innerHTML);}
        if(document.querySelector('#recommendType')) { eval(document.querySelector('#recommendType').innerHTML);}
        if(document.querySelector('#internationalScript')) { eval(document.querySelector('#internationalScript').innerHTML);}
       if(document.querySelector('#characterCount')) { eval(document.querySelector('#characterCount').innerHTML);}
      }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
    
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.add_to_cart').classList.remove('hidden');
           this.querySelector('.updateBtnText').classList.remove('hidden');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });

        })();
    
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = 'Out of stock';
      }
    }
  });
}
